// extracted by mini-css-extract-plugin
export default {"donation":"styles_donation__SzfE5","table_container":"styles_table_container__81efb","donationIcon":"styles_donationIcon__O8Z78"};